<template>
  <v-container
    :id="'asset-container-' + assetType"
    class="page"
  >
    <v-card elevation="0">
      <v-card-title>
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <v-btn
            color="#00ACDC"
            dark
            class="mb-2 ml-auto"
            @click="handleCreateAsset"
          >
            CREATE NEW {{ getType(assetType) }}
          </v-btn>
        </div>
        <v-data-table
          :headers="headers"
          :items="currentFilteredAsset"
          class="font-weight-light pa-5"
          :loading="loadingAssets"
          loading-text="Loading..."
          :footer-props="footerProps"
          @update:options="updatePaging"
          :server-items-length="assetTotal"
          :options.sync="paginationOptions"
        >
          <template #[`item.no`]=" { item }">
            {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + currentFilteredAsset.indexOf(item) + 1 }}
          </template>
          <template #[`item.type`]="{ item }">
            {{ getType(item.type) }}
          </template>
          <template #[`item.action`]="{ item }">
            <v-icon
              small
              class="mr-2"
              color="green"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              @click="deleteItem(item)"
              color="red"
            >
              mdi-delete
            </v-icon>
          </template>
          <template #no-data>
            Asset not available, please create a new asset
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deleteDialog"
      persistent
      max-width="500"
    >
      <v-card
        dark
        color="red"
      >
        <v-card-title>
          <span>
            <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
            this {{ getType(assetType) }}?
          </span>
        </v-card-title>
        <v-card-text>
          You will delete this {{ getType(assetType) }} permanently.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="deleteDialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            @click="deleteAsset()"
            :loading="loadingUpdate"
            :disabled="loadingUpdate"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="createDialog"
      max-width="900"
      persistent
    >
      <v-card
        width="100%"
        style="border-radius:10px;"
        class="pa-9"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-application
              </v-icon>Create {{ getType(assetType) }}
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-alert
          v-model="isExistNumber"
          type="error"
          dismissible
          class="my-0"
        >
          Number already used
        </v-alert>
        <v-card-text class="my-0">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-select
                    hide-details
                    :items="assetTypes"
                    :item-text="(type) => `${type.name}`"
                    :item-value="(type) => `${type.id}`"
                    label="Select Asset Type"
                    outlined
                    v-model="type"
                    disabled
                    required
                    :rules="[(v) => !!v || 'Item is required']"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    label="Number"
                    placeholder="e.g. 2010347890"
                    :rules="[rules.required, rules.min]"
                    v-model="number"
                    required
                    maxlength="20"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Description"
                    :rules="[(v) => !!v || 'Description is required']"
                    v-model="description"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-autocomplete
                    :items="origin"
                    :item-text="(origin) => `${origin.name}`"
                    :item-value="(origin) => `${origin.Id}`"
                    label="Select Origin"
                    append-icon="mdi-map-marker"
                    outlined
                    v-model="origin_id"
                    required
                    hide-details
                    :rules="[(v) => !!v || 'Item is required']"
                  >
                    <template #no-data>
                      <p class="my-0 px-3 pt-1 font-weight-light">
                        No data Origin available. You can create on
                        <b><router-link
                          to="/geofence"
                        >Geofence page</router-link></b>
                      </p>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="!isDarwin"
                >
                  <v-select
                    hide-details
                    :items="cabinets"
                    :item-text="(cabinet) => `${cabinet.name}`"
                    :item-value="(cabinet) => `${cabinet.id}`"
                    label="Select Cabinet"
                    outlined
                    v-model="metadata.cabinet_id"
                    @change="metadata.cabinet_item_number = null"
                    clearable
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="metadata.cabinet_id"
                >
                  <v-select
                    hide-details
                    :items="cabinetItemsForCreate"
                    item-text="number"
                    item-value="number"
                    label="Select Key Cabinet Number"
                    outlined
                    v-model="metadata.cabinet_item_number"
                    :rules="[(v) => {
                      if (!!metadata.cabinet_id) {
                        return !!v || 'Item is required';
                      }
                      return false;
                    }]"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="my-0">
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="close"
                block
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="save"
                block
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editDialog"
      max-width="900"
      persistent
    >
      <v-card
        :id="'edit-asset-' + assetType"
        width="100%"
        style="border-radius:10px;"
        class="pa-9"
        outlined
      >
        <v-toolbar
          light
          flat
        >
          <v-spacer />
          <div class="pt-3">
            <p class="text-center headline">
              <v-icon
                color="#00ACDC"
                class="mx-2"
              >
                mdi-application
              </v-icon>Update asset
            </p>
          </div>
          <div class="flex-grow-1" />
        </v-toolbar>
        <v-card-text class="my-0">
          <v-form
            ref="formEdit"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-select
                    hide-details
                    :items="assetTypes"
                    :item-text="(type) => `${type.name}`"
                    :item-value="(type) => `${type.id}`"
                    label="Select Asset Type"
                    outlined
                    v-model="editedItem.type"
                    disabled
                    required
                    :rules="[(v) => !!v || 'Item is required']"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    label="Number"
                    placeholder="e.g. 20101001"
                    outlined
                    :rules="[rules.required, rules.min]"
                    v-model="editedItem.number"
                    required
                    maxlength="25"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    outlined
                    hide-details
                    label="Description"
                    :rules="[(v) => !!v || 'Description is required']"
                    v-model="editedItem.description"
                    required
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                >
                  <v-autocomplete
                    :items="origin"
                    :item-text="(origin) => `${origin.name}`"
                    :item-value="(origin) => `${origin.Id}`"
                    label="Select Origin"
                    append-icon="mdi-map-marker"
                    outlined
                    v-model="editedItem.origin_id"
                    required
                    hide-details
                    :rules="[(v) => !!v || 'Item is required']"
                  >
                    <template #no-data>
                      <p class="my-0 px-3 pt-1 font-weight-light">
                        No data Origin available. You can create on
                        <b><router-link
                          to="/geofence"
                        >Geofence page</router-link></b>
                      </p>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="!isDarwin"
                >
                  <v-select
                    hide-details
                    :items="cabinets"
                    :item-text="(cabinet) => `${cabinet.name}`"
                    :item-value="(cabinet) => `${cabinet.id}`"
                    label="Select Cabinet"
                    outlined
                    v-model="editedItem.metadata.cabinet_id"
                    @change="editedItem.metadata.cabinet_item_number = null"
                    :disabled="!cabinetLoaded"
                    clearable
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  v-if="editedItem.metadata.cabinet_id && cabinetLoaded"
                >
                  <v-select
                    hide-details
                    :items="cabinetItemsForEdit"
                    item-text="number"
                    item-value="number"
                    label="Select Key Cabinet Number"
                    outlined
                    v-model="editedItem.metadata.cabinet_item_number"
                    :rules="[(v) => {
                      if (!!editedItem.metadata.cabinet_id) {
                        return !!v || 'Item is required';
                      }
                      return false;
                    }]"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions class="my-0">
          <v-row>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="closeEdit"
                block
                type="submit"
                color="error"
              >
                CLOSE
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              sm="6"
            >
              <v-btn
                @click="saveEdit"
                block
                type="submit"
                color="success"
                :loading="loadingUpdate"
                :disabled="loadingUpdate"
              >
                SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";

export default {
  props: {
    assetType: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    token: "",
    clientid: "",
    headers: [
      { text: "No", value: "no", sortable: false },
      { text: "Asset type", align: "left", value: "type" },
      { text: "Number", value: "number" },
      { text: "Description", value: "description" },
      { text: "Actions", value: "action", sortable: false },
    ],
    deleteDialog: false,
    createDialog: false,
    editDialog: false,
    deletedIndex: null,
    origin_id: "",
    deletedItem: {},
    editedIndex: null,
    editedItem: {
      type: "",
      number: "",
      description: "",
      id: "",
      clientid: "",
      origin_id: "",
      metadata: {
        cabinet_id: "",
        cabinet_item_number: "",
      },
    },
    getAssets: [],
    valid: true,
    payloadApi: {},
    type: "",
    number: "",
    description: "",
    assetTypes: [],
    metadata: {
      cabinet_id: "",
      cabinet_item_number: "",
    },
    cabinetsUsage: [],
    loadingUpdate: false,
    loader: null,
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => v.length >= 1 || "Min 1 digits",
    },
    searchData: "",
    searchDataTimeout: null,
    isExistNumber: false,
    assetTotal: 0,
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    },
    loadingAssets: false
  }),
  created() {
    this.$store.commit("CLEAR_CABINETS");
    this.token = this.$store.state.token;
    this.clientid = this.$store.state.clientid;
    this.$store.dispatch("GET_GEOFENCES");
    this.getAssetTotal();
    this.getAssetsData();
    this.getAssetTypes();
    this.loadCabinetsUsage();
    this.$store.dispatch("LOAD_CABINETS");
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    searchData(query) {
      clearTimeout(this.searchDataTimeout)
      this.searchDataTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];
        this.getAssetTotal();
        this.getAssetsData();
      }, 1e3)
    }
  },
  methods: {
    loadCabinetsUsage() {
      const { clientid } = this.$store.state;
      this.$store.dispatch('API_CALL', {
          $method: 'get_cabinets_usage',
          $postData: {
            clientid,
          },
        })
        .then((response) => {
          if (response && response.data && response.data.data) {
            this.cabinetsUsage = response.data.data;
          }
        });
    },
    getAssetTypes() {
      this.$store.dispatch('API_CALL', {
          $method: 'get_asset_types',
          $postData: {
            clientid: this.$store.state.clientid,
          },
        })
        .then((response) => {
          this.assetTypes = response.data.data.filter(
            (type) => parseInt(type.is_vehicle) === 0
          );
        });
    },
    saveEdit() {
      if (this.$refs.formEdit.validate()) {
        const item = this.getAssets.find((d) => d.id == this.editedItem.id);
        this.editDialog = false;

        this.loadingUpdate = true;
        this.loader = this.loadingUpdate;

        const datas = {
          clientid: this.clientid,
          id: item.id,
          type: this.editedItem.type,
          number: this.editedItem.number,
          description: this.editedItem.description,
          origin_id: this.editedItem.origin_id,
          metadata: {
            cabinet_id: this.editedItem.metadata.cabinet_id,
            cabinet_item_number: this.editedItem.metadata.cabinet_item_number,
          },
        };

        this.$store.dispatch('API_CALL', {
            $method: 'update_asset',
            $postData: {
              data: datas,
            },
          })
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Success update asset",
            });
            this.loadingUpdate = false;
            this.loader = this.loadingUpdate;
            this.getAssetTotal();
            this.getAssetsData();
            this.loadCabinetsUsage();
          });
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        const existNumber = this.getAssets.find(
          (asset) => asset.number === this.number
        );
        if (existNumber) {
          this.isExistNumber = true;
        } else {
          this.payloadApi = {
            clientid: this.clientid,
            type: this.type,
            number: this.number,
            description: this.description,
            origin_id: this.origin_id,
            metadata: {
              cabinet_id: this.metadata.cabinet_id,
              cabinet_item_number: this.metadata.cabinet_item_number,
            },
          };
          this.loadingUpdate = true;
          this.loader = this.loadingUpdate;
          this.$store.dispatch('API_CALL', {
              $method: 'create_asset',
              $postData: {
                data: this.payloadApi,
              },
            })
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Success create asset",
              });
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              this.getAssetTotal();
              this.getAssetsData();
              this.loadCabinetsUsage();
              this.close();
            });
        }
      }
    },
    close() {
      this.createDialog = false;
      this.$refs.form.reset();
    },
    closeEdit() {
      this.editDialog = false;
      this.$refs.formEdit.reset();
    },
    getAssetTotal() {
      if (this.loadingAssets) return
      return this.$store.dispatch('API_CALL', {
        $method: 'get_asset_total',
        $postData: {
          clientid: this.$store.state.clientid,
          query: this.searchData,
          type: this.assetType
        },
      }).then((response) => {
        this.assetTotal = parseInt(get(response, 'data.data.total', '0'), 10);
      })
    },
    getAssetsData() {
      if (this.loadingAssets) return
      this.clientid = this.clientid;
      this.loadingAssets = true;

      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by  = sortBy.length ? sortBy[0] : 'number';
      const sort_dir = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'asc';
      const offset   = (page - 1) * itemsPerPage;

      return this.$store.dispatch('API_CALL', {
          $method: 'get_assets',
          $postData: {
            clientid: this.clientid,
            limit: itemsPerPage,
            offset,
            sort_by,
            sort_dir,
            query: this.searchData,
            type: this.assetType
          },
        })
        .then((response) => {
          this.getAssets = response.data.data;
          this.loadingAssets = false;
        });
    },
    deleteItem(item) {
      this.deleteDialog = true;
      this.deletedIndex = this.getAssets.indexOf(item);
      this.deletedItem = Object.assign({}, item);
    },
    editItem(item) {
      this.editDialog = true;
      this.editedIndex = this.getAssets.indexOf(item);
      item.metadata.cabinet_item_number = item.metadata.hasOwnProperty(
        "cabinet_item_number"
      )
        ? item.metadata.cabinet_item_number
        : "";
      this.editedItem = cloneDeep(item);
    },
    deleteAsset() {
      const item = this.getAssets.find((d) => d.id == this.deletedItem.id);
      this.loadingUpdate = true;
      this.loader = this.loadingUpdate;
      this.$store.dispatch('API_CALL', {
          $method: 'delete_asset',
          $postData: {
            id: item.id,
          },
        })
        .then(() => {
          this.deleteDialog = false;
          this.loadingUpdate = false;
          this.$swal({
            icon: "success",
            title: "Success delete asset",
          });
          this.loader = this.loadingUpdate;
          Promise.all([
            this.getAssetTotal(),
            this.getAssetsData(),
            this.loadCabinetsUsage(),
          ]).then(() => {
            if (this.assetTotal > 0 && this.getAssets.length === 0) {
              this.paginationOptions.page = 1
              this.getAssetTotal();
              this.getAssetsData();
              this.loadCabinetsUsage();
            }
          })
        });
    },
    getType(type) {
      if (isNaN(parseInt(type))) return "";
      const currentType = this.assetTypes.find(
        (t) => parseInt(t.id) === parseInt(type)
      );
      return currentType ? currentType.name : "";
    },
    handleCreateAsset() {
      this.createDialog = true;
      this.type = this.assetType.toString();
      this.editedIndex = null;
      this.editedItem = {
        type: "",
        number: "",
        description: "",
        id: "",
        clientid: "",
        origin_id: "",
        metadata: {
          cabinet_id: "",
          cabinet_item_number: "",
        },
      };
    },
    updatePaging(options) {
      this.getAssetTotal();
      this.paginationOptions = options;
      this.getAssetsData();
    },
  },
  computed: {
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
    origin() {
      const group = this.geofences[this.$store.state.clientid].filter(
        (obj) =>
          obj.name == "Carpool Origin - Destination" ||
          obj.name == "Carpool Origin" ||
          obj.name == 'Carpool Origin without Key Cabinet'
      );
      let data = [];
      group.map((group) => {
        data = group.geofences;
      })

      return data.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
    },
    currentFilteredAsset() {
      return this.getAssets.filter(
        (asset) => parseInt(asset.type) === parseInt(this.assetType)
      );
    },
    cabinetLoaded() {
      return this.$store.getters["getCabinetLoaded"];
    },
    cabinets() {
      return this.$store.getters["getCabinets"];
    },
    cabinetItemsForCreate() {
      let cabinet_id = null;

      if (this.metadata.cabinet_id) {
        cabinet_id = this.metadata.cabinet_id;
      }

      const cabinet = this.cabinets.find(
        (cabinet) => cabinet.id === cabinet_id
      );

      if (!cabinet) return [];

      const matchCabinet = this.cabinetsUsage.find((c) => c.cabinet === cabinet_id);
      let items = get(cabinet, "items", []);

      if (!matchCabinet) return items;

      return items.filter((i) => {
        const itemNo = parseInt(i.number, 10);
        const used = matchCabinet.items
          .find((ui) => parseInt(ui.item_no, 10) === itemNo);
        return !used;
      }).map(({ number }) => ({ number: number.toString() }));
    },
    cabinetItemsForEdit() {
      let cabinet_id = null;

      if (this.editedItem.metadata.cabinet_id) {
        cabinet_id = this.editedItem.metadata.cabinet_id;
      }

      const cabinet = this.cabinets.find(
        (cabinet) => cabinet.id === cabinet_id
      );

      if (!cabinet) return [];

      const matchCabinet = this.cabinetsUsage.find((c) => c.cabinet === cabinet_id);
      let items = get(cabinet, "items", []);

      if (!matchCabinet) return items;

      return items.filter((i) => {
        const itemNo = parseInt(i.number, 10);
        const used = matchCabinet.items
          .find((ui) => parseInt(ui.item_no, 10) === itemNo);
        const editedAsset = this.getAssets[this.editedIndex];
        if (editedAsset.metadata.cabinet_id === cabinet_id) {
          const currentItemNo = parseInt(editedAsset.metadata.cabinet_item_number, 10);
          if (!isNaN(currentItemNo) && itemNo === currentItemNo) {
            return true;
          }
        }
        return !used;
      }).map(({ number }) => ({ number: number.toString() }));
    },
    isDarwin() {
      return this.$store.state.clientid === "ED73T6OILP78";
    }, 
  },
};
</script>
<style lang="css" scoped></style>
